'use client';

import { ContactModalProvider } from '../contexts/ContactModalContext';
import ContactModal from './ContactModal';

export default function Providers({ children }: { children: React.ReactNode }) {
    return (
        <ContactModalProvider>
            {children}
            <ContactModal />
        </ContactModalProvider>
    );
}
